export default __webpack_public_path__ + "static/media/Avatar-20-noback.027b6bea.png";